import React, { useMemo } from 'react';
import FailedChecksSummaryList from './FailedChecksSummaryList';
import { useNavigate } from '../../router/hooks/useNavigate';
import useBatchUrlAnalysisProcessesPolling from '../process/hooks/useBatchUrlAnalysisProcessesPolling';
import { useFetchOnPageSeoFailedDomainChecksQuery } from './service';
import { DPA_DASHBOARD_POLLING_TIME_MS } from '../settings';

type Props = {
    websiteGuid: string;
};

export default function WebsiteConfigurationFailedChecks({ websiteGuid }: Props) {
    const navigate = useNavigate();

    const { isRunningBatchAnalysis } = useBatchUrlAnalysisProcessesPolling(websiteGuid);
    const { data: failedChecks, isLoading: isLoadingFailedChecks } = useFetchOnPageSeoFailedDomainChecksQuery(
        { w_guid: websiteGuid },
        {
            // The polling interval is in milliseconds!
            pollingInterval: isRunningBatchAnalysis ? DPA_DASHBOARD_POLLING_TIME_MS : 0,
            // The polling interval is reset if we call the hook again, refetchOnMount
            // Can take a number that will refetch if the cache value is older than the value
            // This is in seconds!
            refetchOnMountOrArgChange: isRunningBatchAnalysis ? DPA_DASHBOARD_POLLING_TIME_MS / 1000 : false,
        }
    );

    const handleFailedCheckButtonClick = (seoTestKey: string) => {
        navigate(`/deep-analysis/report/?w_guid=${websiteGuid}#${seoTestKey}`);
    };

    const sortedChecks = useMemo(
        () => (failedChecks && failedChecks.length > 0 ? [...failedChecks].sort((a, b) => b.relevance - a.relevance) : []),
        [failedChecks]
    );

    const lastFoundDate = failedChecks && failedChecks[0] && failedChecks[0].last_found;

    return (
        <FailedChecksSummaryList
            title="Site-wide SEO issues"
            type="website"
            failedChecks={sortedChecks}
            lastFoundDate={lastFoundDate}
            isLoading={isLoadingFailedChecks}
            isRunningBatchAnalysis={isRunningBatchAnalysis}
            onFailedCheckButtonClicked={handleFailedCheckButtonClick}
        />
    );
}
